import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { swalMessages } from '@auteco/constants';
import pricesService from '@auteco/services/pricesService';
import PromotionPage from '@auteco/pages/MaestrosPage/PromotionPage/PromotionPage';
import { loaderService } from '@auteco/services/loaderService';

const PromotionContainer = () => {
  const [tableInfo, setTableInfo] = useState([]);

  const getTableInfo = async () => {
    loaderService.show();
    const response = await pricesService.getPrices();
    if (response.status === 200 && response.data.success) {
      setTableInfo(response.data.data);
      loaderService.hide();
    } else {
      loaderService.hide();
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const updatePromotion = async ({ newData }) => {
    const date = new Date().toISOString().slice(0, 10);
    const { success, id } = await pricesService.postPromotion({
      uuid_segmentacion: newData.SEGMENTACION_UUID,
      valor: `${newData.PROMO_VALOR}`,
      descripcion: newData.PROMO_DESCRIPCION,
      fecha_creacion: date,
    });
    if (success) {
      const updatedPromotion = tableInfo.map((item) => {
        if (item.SEGMENTACION_UUID === newData.SEGMENTACION_UUID) {
          return {
            ...item,
            ...newData,
            PROMO_CREACION: date,
            PROMO_UUID: id,
          };
        }
        return item;
      });
      swal(swalMessages.SUCCESFUL_UPDATE);
      setTableInfo(updatedPromotion);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onDeletePromotion = async (oldData) => {
    swal(swalMessages.DELETE_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        const { success } = await pricesService.deletePromotion(oldData.PROMO_UUID);
        if (success) {
          const updatedPromotion = tableInfo.map((item) => {
            if (item.SEGMENTACION_UUID === oldData.SEGMENTACION_UUID) {
              return {
                ...item,
                ...oldData,
                PROMO_VALOR: 0.0,
                PROMO_DESCRIPCION: '',
              };
            }
            return item;
          });
          setTableInfo(updatedPromotion);
          swal(swalMessages.SUCCEFUL_DELETE);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  useEffect(() => {
    getTableInfo();
  }, []);

  return (
    <PromotionPage
      tableInfo={tableInfo}
      updatePromotion={updatePromotion}
      onDeletePromotion={onDeletePromotion}
    />
  );
};

export default PromotionContainer;
